import { render, staticRenderFns } from "./Fotos.vue?vue&type=template&id=11ec3727&scoped=true"
import script from "./Fotos.vue?vue&type=script&lang=js"
export * from "./Fotos.vue?vue&type=script&lang=js"
import style0 from "./Fotos.vue?vue&type=style&index=0&id=11ec3727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ec3727",
  null
  
)

export default component.exports